import * as React from 'react';

import { useApplicationContext } from '../applicationContext';
import { toError } from '../toError';

/**
 * Обработчик ошибки загрузки чанка для @loadable/component.
 * Вместо throw в render (он дошёл бы до корневого error boundary и стёр страницу) возвращает
 * пустой компонент, который при монтировании пишет ошибку в logger из контекста приложения.
 * P — пропсы ленивого компонента, чтобы fallback не сужал тип loadable.
 */
export function handleChunkLoadError<P = {}>(chunk: string) {
  return (error: unknown): { default: React.ComponentType<P> } => ({
    default: createChunkLoadErrorFallback<P>(chunk, toError(error)),
  });
}

function createChunkLoadErrorFallback<P>(chunk: string, error: Error): React.ComponentType<P> {
  const ChunkLoadErrorFallback: React.FC<P> = () => {
    const { logger } = useApplicationContext();

    React.useEffect(() => {
      logger.error(error, { domain: 'loadable.chunkLoadFailed', chunk });
    }, [logger]);

    return null;
  };

  ChunkLoadErrorFallback.displayName = `ChunkLoadErrorFallback(${chunk})`;

  return ChunkLoadErrorFallback;
}
